<template>
  <div class="!pt-0">
    <div class="flex flex-col space-y-6 max-h-screen pt-16 pb-2.5">
      <!-- Header Section -->
      <div class="flex items-center justify-between space-x-4 mt-2.5">
        <div class="flex items-center space-x-4 element-island">
          <div class="flex items-center space-x-3">
            <div class="w-10 h-10 bg-gradient-to-r from-ccm-orange-500 to-ccm-orange-600 rounded-lg flex items-center justify-center">
              <svg
    fill="none"
    stroke="currentColor"
    viewBox="0 0 24 24"
 class="w-5 h-5 text-white">
    <path
        stroke-linecap="round"
        stroke-linejoin="round"
        stroke-width="2"
        d="M17 20h5v-2a3 3 0 00-5.356-1.857M17 20H7m10 0v-2c0-.656-.126-1.283-.356-1.857M7 20H2v-2a3 3 0 015.356-1.857M7 20v-2c0-.656.126-1.283.356-1.857m0 0a5.002 5.002 0 019.288 0M15 7a3 3 0 11-6 0 3 3 0 016 0zm6 3a2 2 0 11-4 0 2 2 0 014 0zM7 10a2 2 0 11-4 0 2 2 0 014 0z"
    />
</svg>
            </div>

            <div>
              <h1 class="font-bold text-2xl text-gray-900">
                {{ $t('SelfPerform.LabourDashboard.title') }}
              </h1>

              <p class="text-sm text-gray-600">
                {{ $t('SelfPerform.LabourDashboard.subTitle') }}
              </p>
            </div>
          </div>

          <a
            :href="exportUrl"
            target="_blank"
            class="btn btn--secondary-blue inline-flex items-center space-x-2"
          >
            <svg fill="none" stroke="currentColor" viewBox="0 0 24 24" class="w-4 h-4">
<path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 10v6m0 0l-3-3m3 3l3-3m2 8H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" />
</svg>

            <span>{{ $t('SelfPerform.LabourDashboard.button.export') }}</span>
          </a>
        </div>

        <div class="flex space-x-3 element-island">
          <button
            v-if="projectsStore.project?.unarchived"
            type="button"
            class="btn btn--primary-blue inline-flex items-center space-x-2"
            data-test="add-labour"
            @click="show = true"
          >
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" class="w-4 h-4">
  <path fill-rule="evenodd" d="M12 3.75a.75.75 0 01.75.75v6.75h6.75a.75.75 0 010 1.5h-6.75v6.75a.75.75 0 01-1.5 0v-6.75H4.5a.75.75 0 010-1.5h6.75V4.5a.75.75 0 01.75-.75z" clip-rule="evenodd" />
</svg>

            <span>{{ $t('SelfPerform.LabourDashboard.button.addLabour') }}</span>
          </button>

          <button
            type="button"
            class="btn inline-flex items-center space-x-2"
            :class="[laboursStore.active ? 'btn--primary-blue' : 'btn--secondary-blue']"
            data-test="show-filter"
            @click="showFilter = true"
          >
            <svg
    fill="none"
    stroke="currentColor"
    viewBox="0 0 24 24"
    xmlns="http://www.w3.org/2000/svg"
 class="w-4 h-4">
    <path
    stroke-linecap="round"
    stroke-linejoin="round"
    stroke-width="2"
    d="M3 4a1 1 0 011-1h16a1 1 0 011 1v2.586a1 1 0 01-.293.707l-6.414 6.414a1 1 0 00-.293.707V17l-4 4v-6.586a1 1 0 00-.293-.707L3.293 7.293A1 1 0 013 6.586V4z"
    />
</svg>

            <span>{{ $t('SelfPerform.LabourDashboard.button.filter') }}</span>
          </button>
        </div>
      </div>

      <!-- Main Content -->
      <div
        v-if="labours.length === 0 && fetchLaboursAction.state.value === States.COMPLETE"
        class="element-island text-center py-12"
        data-test="no-labour-message"
      >
        <div class="w-24 h-24 bg-gray-100 rounded-full flex items-center justify-center mx-auto mb-6">
          <svg
    fill="none"
    stroke="currentColor"
    viewBox="0 0 24 24"
 class="w-12 h-12 text-gray-400">
    <path
        stroke-linecap="round"
        stroke-linejoin="round"
        stroke-width="2"
        d="M17 20h5v-2a3 3 0 00-5.356-1.857M17 20H7m10 0v-2c0-.656-.126-1.283-.356-1.857M7 20H2v-2a3 3 0 015.356-1.857M7 20v-2c0-.656.126-1.283.356-1.857m0 0a5.002 5.002 0 019.288 0M15 7a3 3 0 11-6 0 3 3 0 016 0zm6 3a2 2 0 11-4 0 2 2 0 014 0zM7 10a2 2 0 11-4 0 2 2 0 014 0z"
    />
</svg>
        </div>

        <h3 class="text-lg font-semibold text-gray-900 mb-2">
          {{ $t('SelfPerform.LabourDashboard.noLabourFound') }}
        </h3>

        <p class="text-gray-600 mb-6">
          {{ $t('SelfPerform.LabourDashboard.tryAdjustingFilters') }}
        </p>

        <button
          v-if="projectsStore.project?.unarchived"
          type="button"
          class="btn btn--primary-blue inline-flex items-center space-x-2"
          @click="show = true"
        >
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" class="w-4 h-4">
  <path fill-rule="evenodd" d="M12 3.75a.75.75 0 01.75.75v6.75h6.75a.75.75 0 010 1.5h-6.75v6.75a.75.75 0 01-1.5 0v-6.75H4.5a.75.75 0 010-1.5h6.75V4.5a.75.75 0 01.75-.75z" clip-rule="evenodd" />
</svg>

          <span>{{ $t('SelfPerform.LabourDashboard.button.addFirstLabour') }}</span>
        </button>
      </div>

      <div
        v-else-if="fetchLaboursAction.state.value === States.COMPLETE"
        class="element-island overflow-y-auto"
      >
        <LabourList
          :labours="labours"
          :project-id="$props.projectId"
        />
      </div>

      <div
        v-else
        class="element-island flex items-center justify-center py-12"
      >
        <AppSpinner class="h-8 w-8" />
      </div>


      <!-- Modals -->
      <LabourSaveModal
        v-if="show"
        :project-id="$props.projectId"
        @close="show = false"
      />

      <LabourFilterModal
        v-if="showFilter"
        @close="showFilter = false"
        @filter="setFilter"
        @clear="clearFilter"
      />
    </div>
  </div>
</template>

<script setup lang="ts">
import LabourFilterModal from '@/components/LabourDashboard/LabourFilterModal.vue';
import LabourList from '@/components/LabourDashboard/LabourList.vue';
import LabourSaveModal from '@/components/LabourDashboard/LabourSaveModal.vue';
import { useProjectTypeRedirect } from '@/composables/useProjectTypeRedirect';
import { States, useStoreApiAction } from '@/composables/useStoreApiAction';
import { useLaboursStore } from '@/store/labours';
import { useProjectsStore } from '@/store/projects';
import { useVariationOrdersStore } from '@/store/variationOrders';
import { useWbsCodesStore } from '@/store/wbsCodes';
import { route } from '@/ziggy-shim';
import { computed, ref, watch } from 'vue';

const props = defineProps<{
  projectId: string;
}>();

const laboursStore = useLaboursStore();
const fetchLaboursAction = useStoreApiAction(laboursStore.fetchLabours);
const wbsCodesStore = useWbsCodesStore();
const fetchWbsCodesAction = useStoreApiAction(wbsCodesStore.index);
const variationOrdersStore = useVariationOrdersStore();
const fetchApprovedVariations = useStoreApiAction(variationOrdersStore.fetchApprovedVariationOrders);

watch(() => props.projectId, () => {
  laboursStore.filter.resetData();

  fetchLaboursAction.request(props.projectId, laboursStore.filter.form).catch((error) => {
    console.log(error);
  });

  fetchWbsCodesAction.request(props.projectId).catch((error) => {
    console.log(error);
  });

  fetchApprovedVariations.request(props.projectId);
}, { immediate: true });

const show = ref(false);
const showFilter = ref(false);

const labours = computed(() =>
  laboursStore.models
    .with('supplier')
    .with('records', (query) =>
      query
        .with('wbsCode')
        .with('comments', (query) => query.with('creator'))
        .with('user')
        .with('labour')
        .orderBy('day'))
    .where('project_id', parseInt(props.projectId))
    .get()
);

const clearFilter = () => {
  showFilter.value = false;
  laboursStore.filter.resetData();
  laboursStore.models.flush();
  laboursStore.active = false;

  fetchLaboursAction.request(props.projectId).catch((error) => {
    console.log(error);
  });
};

const setFilter = () => {
  showFilter.value = false;
  laboursStore.models.flush();

  fetchLaboursAction.request(props.projectId, laboursStore.filter.form).then(() => {
    laboursStore.active = true;
  }).catch((error) => {
    console.log(error);
  });
};

const projectsStore = useProjectsStore();

const exportUrl = computed(() => {
  if(projectsStore.project) {
    return route('api.v1.projects.export', projectsStore.project.id);
  }

  return undefined;
});

useProjectTypeRedirect();
</script>

<style scoped></style>
